$('.form-group input[type="file"]').change(function() {
  var container = $(this).parents('.form-group');
  var file = this.files[0];
  if (file) {
      preparePreview(file,container);
      uploadFile(file,container);
  }
});
function preparePreview(file,container) {
  console.log(container);
  // Reset potential changes from previous uploads
  $(container).find('.mrk-progress').show();
  $(container).find('.mrk-upload').css('width', '0%');
}
function uploadFile(file,container) {
  var formData = new FormData();
  formData.append('file', file);
  $.ajax({
      // url: 'https://jrsindustrial-files.com',
      url: 'https://homeoutlet.ie/upload.php',
      type: 'POST',
      data: formData,
      cache: false,
      contentType: false,
      processData: false,
      xhr: function() {
          var xhr = new XMLHttpRequest();
          xhr.upload.addEventListener("progress", function(e) {
              if (e.lengthComputable) {
                  var percentComplete = (e.loaded / e.total) * 100;
                  $(container).find('.mrk-upload').css('width', percentComplete + '%');
              }
          });
          return xhr;
      },
      success: function(response) {
          // console.log(response);
          // response = JSON.parse(response);
          var url = 'https://homeoutlet.ie/' + response.filePath;
          $(container).find('input[type="hidden"]').val(url);
          $(container).find('.mrk-progress').hide(); // Hide the progress bar on success
      },
      error: function(jqXHR, textStatus, errorThrown) {
        $(container).find('.mrk-progress').hide(); // Hide the progress bar on error
      }
  });
}